<div class="d-flex align-items-center mb-1">
  <ng-container *ngIf="isBeingModified; else displayValue">
    <input #inputTitle mdbInput type="text" class="h2-input" [formControl]="control" [maxlength]="maxlength" (blur)="isBeingModified = false" jhiMarkAsterisk />
  </ng-container>
  <ng-template #displayValue>
    <h2 class="mb-0">{{ value }}</h2>
    <jhi-bary-icon icon="pen-to-square" [faDirective]="FAS" class="ml-2" (click)="toModify()"></jhi-bary-icon>
  </ng-template>
</div>
